import { render, staticRenderFns } from "./Level1-2.vue?vue&type=template&id=6f35b221&scoped=true&"
import script from "./Level1-2.vue?vue&type=script&lang=js&"
export * from "./Level1-2.vue?vue&type=script&lang=js&"
import style0 from "./Level1-2.vue?vue&type=style&index=0&id=6f35b221&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f35b221",
  null
  
)

export default component.exports